import Switch from "./Switch";

export {
    Switch as default,
};
